import { render, staticRenderFns } from "./platinum_mobile.vue?vue&type=template&id=7f526a0e&scoped=true&"
import script from "./platinum_mobile.vue?vue&type=script&lang=js&"
export * from "./platinum_mobile.vue?vue&type=script&lang=js&"
import style0 from "./platinum_mobile.vue?vue&type=style&index=0&id=7f526a0e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f526a0e",
  null
  
)

export default component.exports